// extracted by mini-css-extract-plugin
module.exports = {"card":"AccountInfo_card__FBWKO","result":"AccountInfo_result__dX4Zy","label":"AccountInfo_label__REAi8"};